export function buildOptions(items, getValue, getLabel) {
    return items.map((item, index) => {
        const value = getValue(item)

        return {
            value: value === undefined || value === null ? '' : String(value),
            label: getLabel(item),
            key: value || index,
        }
    })
}
